import { istek } from './istemci';
import type { Semalar } from './sema';
import type { Kimlik } from './tipler';

/** BİLDİRİM UÇLARI. Tipler `schema.d.ts`ten TÜRETİLİR; elle yazılmaz. */

export type BildirimKanal = Semalar['BildirimOzetiDto']['kanal'];
export type BildirimDurum = Semalar['BildirimOzetiDto']['durum'];
export type BildirimOzeti = Semalar['BildirimOzetiDto'];
export type OkunmamisSayisi = Semalar['OkunmamisSayisiDto'];
export type TumunuOkunduYaniti = Semalar['TumunuOkunduYanitDto'];

/** Okunmamış sayılan durumlar — rozet bunlara göre hesaplanır. */
export const OKUNMAMIS_DURUMLAR: readonly BildirimDurum[] = ['bekliyor', 'gonderildi'];

export function bildirimleriGetir(yalnizOkunmamis = false): Promise<BildirimOzeti[]> {
  return istek<BildirimOzeti[]>('/v1/bildirim', {
    sorgu: { yalnizOkunmamis: yalnizOkunmamis ? 'true' : undefined },
  });
}

export function okunmamisSayisi(): Promise<OkunmamisSayisi> {
  return istek<OkunmamisSayisi>('/v1/bildirim/okunmamis-sayisi');
}

export function bildirimOkundu(bildirimId: Kimlik): Promise<void> {
  return istek<void>(`/v1/bildirim/${bildirimId}/okundu`, { yontem: 'PATCH' });
}

export function tumunuOkundu(): Promise<TumunuOkunduYaniti> {
  return istek<TumunuOkunduYaniti>('/v1/bildirim/tumunu-okundu', { yontem: 'PATCH' });
}
